/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetHoursSummaryForEmployeeRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetHoursSummaryForEmployeeResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getHoursSummaryForEmployee = (request: GetHoursSummaryForEmployeeRequest, options?: CashRequestOptions) => post<GetHoursSummaryForEmployeeRequest, GetHoursSummaryForEmployeeResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetHoursSummaryForEmployee", request, {...options, rejectOnError: true })